import React, { useState, useEffect, FC } from 'react';
import { Form, Button, Input, Message } from 'semantic-ui-react';
import { Grid } from 'semantic-ui-react';
import NoWalletConnected from '../components/NoWalletConnected';
import { provider, userSocialVault } from '../ethereum/web3';

const Create:FC = () => {
  const [isConnected, setIsConnected] = useState<boolean>((window as any).ethereum !== undefined);
  const [minimumContribution, setMinimumContribution] = useState<string>('0');
  const [socialVaultName, setSocialVaultName] = useState<string>('');
  const [nftUrl, setNftUrl] = useState<string>('');
  const [nftName, setNftName] = useState<string>('');
  const [openseaUrl, setOpenseaUrl] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    async function getAccounts() {
      if ((window as any).ethereum) {
        const accounts = await provider.listAccounts();
        setIsConnected(accounts.length > 0);
      }
    }
    getAccounts();
  }, [setIsConnected]);

  async function onSubmit(event: any) {
    event.preventDefault();

    setLoading(true);
    setErrorMessage('');
    try {
      const vars = openseaUrl.split('/');
      const tokenAddress = vars[vars.length - 2];
      const tokenId = vars[vars.length - 1];

      const options = {method: 'GET'};
      const baseUrl = process.env.REACT_APP_DEFAULT_NETWORK === 'rinkeby' 
        ? 'https://rinkeby-api.opensea.io/api/v1/asset' 
        : 'https://api.opensea.io/api/v1/asset';

      await fetch(`https://rinkeby-api.opensea.io/api/v1/asset/${tokenAddress}/${tokenId}/`, options)
      .then(response => response.json())
      .then(response => { 
        setNftUrl(response['image_thumbnail_url']);
        setNftName(response['name']);
      });
      await userSocialVault.createSocialVault(socialVaultName, minimumContribution, nftUrl, nftName, tokenAddress, tokenId);
    } catch (err: any) {
      setErrorMessage(err.message);
    }

    setLoading(false);
  }

  return(
    <Grid columns='equal'>
      <Grid.Column width={1}>
        <div className="outer">
          <div className="inner rotate">CREATE&nbsp;VAULT</div>
        </div>
      </Grid.Column>
      <Grid.Column>
        <div className="App-header">
        { !isConnected ?
          <NoWalletConnected />
        :
          <Form onSubmit={onSubmit} error={!!errorMessage}>
          <Form.Field>
            <label>OpenSea Listing URL</label>
            <Input value={openseaUrl} onChange={event => setOpenseaUrl(event.target.value)} />
          </Form.Field>
          <Form.Field>
            <label>SocialVault Name</label>
            <Input value={socialVaultName} onChange={event => setSocialVaultName(event.target.value)} />
          </Form.Field>
          <Form.Field>
            <label>Target Amount</label>
            <Input
                label="eth"
                labelPosition="right"
                value={minimumContribution}
                onChange={event => setMinimumContribution(event.target.value)}
            />
            </Form.Field>
            <Message error header="Oops!" content={errorMessage} />

            <Button primary loading={loading}>Create</Button>
          </Form>
        }
        </div>
      </Grid.Column>
      <Grid.Column width={1} />
    </Grid>
  );
}

export { Create };
